<template>
	<div class="full">
		<el-container class="full">
			<el-container>
				<el-container>
					<el-main>
						<div class="table">
							<el-tag type="danger" size="mini">上午10点后更新</el-tag>
							<vxe-form :data="formData" @submit="submitEvent" @reset="reset">
								<vxe-form-item title="店铺名称" field="shopname">
									<template #default="{ data }">
										<el-select v-model="data.shopname" size="mini" collapse-tags multiple clearable>
											<el-option v-for="item in shopnameOptions" :key="item.value"
												:value="item.value" :label="item.label"></el-option>
										</el-select>
									</template>
								</vxe-form-item>
								<vxe-form-item title="日期" field="shopname">
									<template #default="{ data }">
										<datePicker :sequence="false" v-model="data.date" />
									</template>
								</vxe-form-item>
								<vxe-form-item>
									<template #default>
										<vxe-button type="submit" status="primary">查询</vxe-button>
										<vxe-button type="reset">重置</vxe-button>
									</template>
								</vxe-form-item>
							</vxe-form>
<!-- 							<vxe-toolbar ref="toolbar" export refresh custom>
								<template #buttons>
									<vxe-button @click="kpiShow" status="primary">设置指标</vxe-button>
								</template>
							</vxe-toolbar> -->
							<vxe-table v-if="tableData.length!=0" border :loading="loading" resizable
								:row-config="{isCurrent: true, isHover: true}" id="bi_bishopflow"
								@header-cell-click="headerCellClickEvent" ref="bishopflow" :data="tableData"
								max-height="70%" :column-config="{isCurrent: true, isHover: true}" :export-config="{}"
								:custom-config="customConfig" :footer-method="footerMethod" show-footer>
								<vxe-column fixed="left" field="shopname" title="店铺名称" show-overflow></vxe-column>
								<vxe-column field="newUv" title="新访客数" sortable></vxe-column>
								<vxe-column field="oldUv" title="老访客数" sortable></vxe-column>
								<vxe-column field="totalUv" title="总访客数" sortable></vxe-column>
								<vxe-column field="newPayByrCnt" title="支付新买家数" sortable></vxe-column>
								<vxe-column field="payOldByrCnt" title="支付老买家数" sortable></vxe-column>
								<vxe-column field="payTotalByrCnt" title="总支付家数" sortable></vxe-column>
								<vxe-column field="payAmt" title="支付金额" sortable></vxe-column>
								<vxe-column field="rfdSucAmt" title="成功退款金额" sortable></vxe-column>
								<vxe-column field="falseAmount" title="刷单金额" sortable></vxe-column>
								<vxe-column field="salesrevenue" title="净销售额" sortable></vxe-column>
								<vxe-column field="rfdSucAmtPercent" title="退款占比" sortable></vxe-column>
								<vxe-column field="payRate" title="支付转化率" sortable></vxe-column>
								<vxe-column field="uvValue" title="UV价值" sortable></vxe-column>
								<vxe-column field="payPct" title="客单价" sortable></vxe-column>
								<vxe-column field="charge" title="总花费" sortable></vxe-column>
								<vxe-column field="chargePercent" title="总花费占比" sortable></vxe-column>
<!-- 								<vxe-column field="targetpayAmt" title="销售额目标" sortable></vxe-column>
								<vxe-column field="percentpayAmt" title="销售额完成度" sortable></vxe-column>
								<vxe-column field="targetpayByrCnt" title="支付买家目标" sortable></vxe-column>
								<vxe-column field="percentpayByrCnt" title="支付买家完成度" sortable></vxe-column>
								<vxe-column field="targetcharge" title="总花费目标" sortable></vxe-column>
								<vxe-column field="percentcharge" title="总花费完成度" sortable></vxe-column> -->
							</vxe-table>
						</div>
<!-- 						<div class="chart" v-if="tableData.length!=0">
							<div class="full flex" style="flex-direction: column;">
								<div style="flex: 1;position: relative;">
									<statistics-chart ref="statisticsChart" :sourceData="sourceData"
										:tableData="tableData" :chartField="chartField" :staticStaff="staticStaff"
										:chartTitle="chartTitle" :date="date" />
								</div>
							</div>
						</div> -->
					</el-main>
				</el-container>
			</el-container>
		</el-container>
<!-- 		<kpiIndex ref="kpiIndex" /> -->
	</div>
</template>
<style>

</style>
<style scoped>
	.table {
		position: relative;
		width: 100%;
		height: 100%;
	}

/* 	.chart {
		position: relative;
		width: 100%;
		height: 40%;
	} */
</style>
<script>
	import datePicker from '@_system/components/formcomponents/common/datePicker/index.vue'
	//import statisticsChart from './statistics.vue'
	// import kpiIndex from './kpi/index.vue'

	export default {
		name: 'bi',
		props: {
			currenttab: {
				default: () => {
					return ''
				}
			}
		},
		data() {
			return {
				loading: false,
				tableShow:false,
				downloaddate: null,
				filterField: ['shopname', 'date'],
				chartField: 'newUv',
				chartTitle: '新访客数',
				staticStaff: [],
				sourceData: [],
				tableData: [],
				shopnameOptions: [],
				formField: {
					shopname: [],
					psnNickName: []
				},
				formData: {
					shopname: [],
					date: null
				},
				date: '',
				customConfig: {
					storage: true
				},
				target: {}

			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.currrentdate()
			this.list()
		},
		computed: {

		},

		methods: {
			list() {
				this.childrenRow = null
				this.loading = true
				let param = JSON.parse(JSON.stringify(this.formData))
				this.$api.BIshopflow.get(param).then((res) => {
					this.$api.BIshopflow.getTarget(this.formData).then((targetres) => {
						this.target = targetres
						this.sourceData = res.tableData
						this.shopnameOptions = res.formField.shopname
						this.tableData = this.createTableData()
						this.loading = false
						//this.createChart()
						
						// this.$nextTick(()=>{
						// 	this.$refs.bishopflow.connect(this.$refs.toolbar)
						// })
					})

				})
			},
			createTableData() {
				let sumFiled = ['payAmt', 'salesrevenue','falseAmount', 'rfdSucAmt', 'newUv', 'oldUv', 'newPayByrCnt', 'payOldByrCnt',
					'rfdSucAmt', 'charge'
				]
				let tableData = []
				let sourceData = JSON.parse(JSON.stringify(this.sourceData))
				sourceData = this.$Lodash.orderBy(sourceData, item => item.process, ['asc'])
				let groupdata = this.$Lodash.groupBy(sourceData, 'shopname')
				let grouptargetdata = this.$Lodash.groupBy(this.target, 'shopname')
				for (let i in groupdata) {
					let obj = {}
					sumFiled.forEach((ele) => {
						obj[ele] = this.$Lodash.sumBy(groupdata[i], item =>
							parseFloat(item[ele]))
						obj[ele] = obj[ele].toFixed(2)
					})
					obj.id = Math.random()
					obj.shopname = i
					obj.payPct = 0
					obj.payRate = 0
					obj.uvValue = 0
					obj.totalUv = parseFloat(obj.newUv) + parseFloat(obj.oldUv)
					obj.uvValue = 0
					obj.payTotalByrCnt = parseFloat(obj.newPayByrCnt) + parseFloat(obj.payOldByrCnt)
					obj.rfdSucAmtPercent = (obj.rfdSucAmt / obj.payAmt * 100).toFixed(2)
					obj.chargePercent = (obj.charge / obj.salesrevenue * 100).toFixed(2)
					if (obj.totalUv) {
						obj.payRate = (obj.payTotalByrCnt / obj.totalUv * 100).toFixed(2)
						obj.uvValue = (obj.payAmt / obj.totalUv).toFixed(2)
					}
					if (obj.payTotalByrCnt) {
						obj.payPct = (obj.payAmt / obj.payTotalByrCnt).toFixed(2)
					}
					//obj.salesrevenue = (parseFloat(obj.payAmt) - parseFloat(obj.rfdSucAmt)).toFixed(2)
					obj.targetpayAmt = this.$Lodash.sumBy(grouptargetdata[i], item =>
						parseFloat(item.targetpayAmt))
					obj.targetpayByrCnt = this.$Lodash.sumBy(grouptargetdata[i], item =>
						parseFloat(item.targetpayByrCnt))
					obj.targetcharge = this.$Lodash.sumBy(grouptargetdata[i], item =>
						parseFloat(item.targetcharge))

					if (obj.targetpayAmt) {
						obj.percentpayAmt = parseFloat(obj.salesrevenue) / parseFloat(obj.targetpayAmt) * 100
						obj.percentpayAmt = obj.percentpayAmt.toFixed(2) + '%'
					}
					if (obj.targetpayByrCnt) {
						obj.percentpayByrCnt = parseFloat(obj.payTotalByrCnt) / parseFloat(obj.targetpayByrCnt) * 100
						obj.percentpayByrCnt = obj.percentpayByrCnt.toFixed(2) + '%'
					}
					if (obj.targetcharge) {
						obj.percentcharge = parseFloat(obj.charge) / parseFloat(obj.targetcharge) * 100
						obj.percentcharge = obj.percentcharge.toFixed(2) + '%'
					}

					obj.salesrevenue = parseFloat(obj.salesrevenue)
					tableData.push(obj)
				}

				tableData = this.$Lodash.orderBy(tableData, ['salesrevenue'], ['desc'])
				// 
				// this.sourceData.forEach((item)=>{
				// 	tableData.push({
				// 		id:item.id,
				// 		shopname:item.shopname,
				// 		newUv:item.newUv.value,
				// 		oldUv:item.oldUv.value,
				// 		newPayByrCnt:item.newPayByrCnt.value,
				// 		payOldByrCnt:item.payOldByrCnt.value,
				// 		payAmt:item.payAmt.value.toFixed(2),
				// 		payRate:item.payRate.value.toFixed(2),
				// 		uvValue:item.uvValue.value.toFixed(2),
				// 		payPct:item.payPct.value.toFixed(2),
				// 		date:item.date
				// 	})
				// })
				return tableData
			},
			currrentdate() {
				let today = new Date()
				let currentTimestamp = today.getTime()
				let preday1 = 24 * 60 * 60 * 1000 * 1
				preday1 = currentTimestamp - preday1
				today = new Date(preday1)
				let firstmonth = new Date(today.getFullYear(), today.getMonth(), 1)
				firstmonth = firstmonth.getTime()
				this.formData.date = [firstmonth, preday1]
				this.downloaddate = preday1
			},
			submitEvent() {
				this.list()
			},
			reset() {
				for (let i in this.formData) {
					this.formData[i] = null
				}
				this.currrentdate()
				this.formData.shopname = []
				this.childrenRow = null
				this.list()
			},
			headerCellClickEvent(e) {

				let filterIndex = this.filterField.findIndex((item) => {
					return item == e.column.field
				})

				if (filterIndex === -1) {
					if (!e.triggerSort) {
						this.chartField = e.column.field
						this.chartTitle = e.column.title
						this.createChart()
					}
				}
			},
			createChart() {
				this.$nextTick(() => {
					this.$refs.statisticsChart.createChart()
				})
			},
			footerMethod({
				columns,
				data
			}) {
				let totalUvSum = 0
				let payTotalByrCntSum = 0
				let salesrevenueSum = 0
				let falseAmountSum = 0
				let rfdSucAmtSum = 0
				columns.forEach((column) => {
					data.forEach((row) => {
						if (column.field == 'totalUv') {
							totalUvSum += row[column.field] ? parseFloat(row[column.field]) : 0
						}
						if (column.field == 'payTotalByrCnt') {
							payTotalByrCntSum += row[column.field] ? parseFloat(row[column.field]) : 0
						}
						if (column.field == 'rfdSucAmt') {
							rfdSucAmtSum += row[column.field] ? parseFloat(row[column.field]) : 0
						}
						
						if (column.field == 'salesrevenue') {
							salesrevenueSum += row[column.field] ? parseFloat(row[column.field]) : 0
						}
						if (column.field == 'falseAmount') {
							falseAmountSum += row[column.field] ? parseFloat(row[column.field]) : 0
						}
					})


				})

				return [
					[
						'合计', '', '', totalUvSum, '', '', payTotalByrCntSum, '', rfdSucAmtSum.toFixed(2),falseAmountSum.toFixed(2), salesrevenueSum.toFixed(2),
					]
				]
			},
			kpiShow() {
				this.$refs.kpiIndex.shopnameList = this.shopnameOptions

				this.$refs.kpiIndex.modalShow()
			}
		},
		components: {
			datePicker,
			//statisticsChart,
			// kpiIndex
		}
	}
</script>